// MYSTERY

import {in_free_spins, server_result, states, wi} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_audio_fade_to,
    madnes_audio_loop,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    fadeout_black_screen,
    fs_start_sound,
    inc_result_control_pos,
    result_control_part,
    result_control_pos
} from "./ps_core_res_ctrl";
import {madnes_loader_completed} from "../framework/src/engine/madnes/madnes_loader";
import {
    madnes_get_dimension_wi,
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_pos, madnes_set_pos_y, madnes_set_texture,
    madnes_set_visible, madnes_sprite_set_frame, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {cylinder_pos, icons} from "./ps_config";
import {array_shuffle, get_array_rand, get_random_int} from "./helpers";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete,
    madnes_anim_play,
    madnes_anim_stop
} from "../framework/src/engine/madnes/madnes_anims";
import {change_bar, fadeout_all_reel_bonus, WinCounter} from "./ps_anims";
import {madnes_alpha_to} from "../framework/src/engine/madnes/madnes_render";
import {madnes_set_font_size, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_money_to_coin, madnes_set_win, madnes_win_anim_reset, win} from "../framework/src/engine/madnes/madnes";
import {calcFontSize, get_text_shift, origFontSize} from "./ps_infomenu";
import {AnimPendulumSine} from "./ps_extanims";
import {STATES} from "../framework/src/states/states";

var mystery_swing_anims = {
    'left': null,
    'right': null,
    'middle': null
};

function start_mystery_rope_swing()
{
    madnes_set_angle("mystery_choose_left_group", 0);
    madnes_set_angle("mystery_choose_middle_group", 0);
    madnes_set_angle("mystery_choose_right_group", 0);

    mystery_swing_anims['left'] = new AnimPendulumSine('mystery_choose_left_group', 0.012, 0.05);
    mystery_swing_anims['left'].run();

    mystery_swing_anims['middle'] = new AnimPendulumSine('mystery_choose_middle_group', 0.008, 0.07, 100);
    mystery_swing_anims['middle'].run();

    mystery_swing_anims['right'] = new AnimPendulumSine('mystery_choose_right_group', 0.01, 0.06);
    mystery_swing_anims['right'].run();

    play_rope_swing_audio();
}

function play_rope_swing_audio()
{
    madnes_audio_loop("mystery_witch");
    var left = get_random_int(0, 1) === 0 ? true : false;

    loop_rope_swing_audio(left);
}

function stop_rope_swing_audio()
{
    //madnes_audio_stop("rope_left");
    //madnes_audio_stop("rope_right");

    madnes_audio_fade_to("mystery_witch", 0, 600, function() {
        madnes_audio_stop("mystery_witch");
    });

    clearTimeout(rope_swing_audio_timeout);
}

var rope_swing_audio_timeout;
function loop_rope_swing_audio(state)
{
    /*if(state) {
        madnes_audio_play("rope_left");
    } else {
        madnes_audio_play("rope_right");
    }*/

    rope_swing_audio_timeout = setTimeout(loop_rope_swing_audio.bind(this, !state), get_random_int(1500, 3000));
}

function stop_mystery_rope_swing()
{
    mystery_swing_anims['left'].stop();
    mystery_swing_anims['left'] = null;

    mystery_swing_anims['middle'].stop();
    mystery_swing_anims['middle'] = null;

    mystery_swing_anims['right'].stop();
    mystery_swing_anims['right'] = null;
}

var mystery_win_set = null;
var mystery_click_timeout = null;
export let mystery_buttons_disabled = false;

export function set_mystery_buttons_disabled(bool) {
    mystery_buttons_disabled = bool;
}

var mystery_audio_loaded = false;

export function mystery_start(win_set)
{
    //madnes_hide_btns();

    states.setState(STATES.BONUS);

    mystery_click_timeout = null;

    if(in_free_spins)
    {
        madnes_audio_stop(fs_start_sound);
    }
    else
    {
        madnes_audio_stop('BACKGROUND');
    }

    mystery_audio_loaded = madnes_loader_completed('myst_audio_bg');

    if(mystery_audio_loaded)
    {
        setTimeout(function() {
            madnes_audio_loop('mystery_background');
        }, 400);
    }



    mystery_win_set = win_set;
    madnes_mystery_count_max = mystery_win_set['win'];
    mystery_core();
}

function mystery_core()
{
    madnes_win_anim_reset();
    prepare_mystery();
}

function hide_all_symbols()
{
    for(var i = 0; i < cylinder_pos.length; i++) {
        for(var j = 0; j <= 2; j++) {
            madnes_set_visible("reels_bufer_" + i + "_S" + j, false);
            madnes_set_visible("reels_bufer_" + i + "_TMP" + j, false);
        }
    }
}

function show_all_symols() {
    for(var i = 0; i < cylinder_pos.length; i++) {
        for(var j = 0; j <= 2; j++) {
            madnes_set_visible("reels_bufer_" + i + "_S" + j, true);
            madnes_set_visible("reels_bufer_" + i + "_TMP" + j, false);
        }
    }
}

var mystery_anim_timeouts = {
    "mystery_img_choose_left": null,
    "mystery_img_choose_middle": null,
    "mystery_img_choose_right": null
};

function stop_mystery_timeout_anims()
{
    for(var i in mystery_anim_timeouts) {
        if(mystery_anim_timeouts[i] !== null) {
            clearTimeout(mystery_anim_timeouts[i]);
        }
    }
}

function mystery_anim_play(spriteName, randomDelay)
{
    var delay = 2800;

    if(randomDelay) {
        delay = get_random_int(0, 4000);
    }

    mystery_anim_timeouts[spriteName] = setTimeout(function() {
        madnes_anim_play(spriteName, "anim_myst_stand", 30);
    }, delay);
}

var mystery_win_txt_pos = 565;

function prepare_mystery()
{
    //madnes_set_visible("logo_reels", false);

    madnes_set_visible("mystery_background", true);
    madnes_set_pos("mystery_background", 0, 0);
    madnes_set_alpha("mystery_background", 0);

    /*if(in_free_spins) {
        anim_slideout_fs();
    } else {
        anim_slideout_logo();
    }*/

    change_bar("none");

    mystery_disable_buttons();

    madnes_set_pos("mystery_choose_left_group", 312, 110);
    madnes_set_visible("mystery_choose_left_group", true);
    madnes_set_angle("mystery_choose_left_group", 0);
    madnes_set_alpha("mystery_choose_left_group", 0);

    madnes_set_pos("mystery_choose_middle_group", wi / 2, 170);
    madnes_set_visible("mystery_choose_middle_group", true);
    madnes_set_angle("mystery_choose_middle_group", 0);
    madnes_set_alpha("mystery_choose_middle_group", 0);

    madnes_set_pos("mystery_choose_right_group", 980, 110);
    madnes_set_visible("mystery_choose_right_group", true);
    madnes_set_angle("mystery_choose_right_group", 0);
    madnes_set_alpha("mystery_choose_right_group", 0);


    madnes_set_visible("mystery_img_choose_left", true);
    madnes_set_texture("mystery_img_choose_left", "symbols_atlas");
    madnes_sprite_set_frame_name("mystery_img_choose_left", "symbol_Mystery");
    madnes_set_pos("mystery_img_choose_left", 0, 110);

    madnes_set_visible("mystery_img_choose_middle", true);
    madnes_set_texture("mystery_img_choose_middle", "symbols_atlas");
    madnes_sprite_set_frame_name("mystery_img_choose_middle", "symbol_Mystery");

    madnes_set_pos("mystery_img_choose_middle", 0, 50);

    madnes_set_visible("mystery_img_choose_right", true);
    madnes_set_texture("mystery_img_choose_right", "symbols_atlas");
    madnes_sprite_set_frame_name("mystery_img_choose_right", "symbol_Mystery");
    madnes_set_pos("mystery_img_choose_right", 0, 110);

    madnes_set_pos("mystery_label", wi / 2, 20);
    madnes_set_visible("mystery_label", true);
    madnes_set_alpha("mystery_label", 0);

    madnes_set_pos("mystery_btn_choose_left", 199 + 216 / 2, 508 + 86 / 2);
    //madnes_sprite_set_frame("mystery_btn_choose_left", 0);
    madnes_set_visible("mystery_btn_choose_left", true);
    madnes_set_alpha("mystery_btn_choose_left", 0);

    madnes_set_pos("mystery_btn_choose_middle", 533 + 216 / 2, 508 + 86 / 2);
    //madnes_sprite_set_frame("mystery_btn_choose_middle", 1);
    madnes_set_visible("mystery_btn_choose_middle", true);
    madnes_set_alpha("mystery_btn_choose_middle", 0);

    madnes_set_pos("mystery_btn_choose_right", 867 + 216 / 2, 508 + 86 / 2);
    //madnes_sprite_set_frame("mystery_btn_choose_right", 0);
    madnes_set_visible("mystery_btn_choose_right", true);
    madnes_set_alpha("mystery_btn_choose_right", 0);


    madnes_set_pos("mystery_win_txt_left", 400, mystery_win_txt_pos);
    madnes_set_visible("mystery_win_txt_left", false);
    madnes_set_pos("mystery_win_txt_middle", 734, mystery_win_txt_pos);
    madnes_set_visible("mystery_win_txt_middle", false);
    madnes_set_pos("mystery_win_txt_right", 1070, mystery_win_txt_pos);
    madnes_set_visible("mystery_win_txt_right", false);

    var alphatoTime = 900;

    madnes_alpha_to("mystery_background", 1, alphatoTime, function() {
        hide_all_symbols();
    });


    madnes_alpha_to("mystery_btn_choose_left", 1, alphatoTime);
    madnes_alpha_to("mystery_btn_choose_middle", 1, alphatoTime);
    madnes_alpha_to("mystery_btn_choose_right", 1, alphatoTime);

    setTimeout(function() {

        madnes_alpha_to("mystery_label", 1, alphatoTime - 300);

        madnes_alpha_to("mystery_choose_left_group", 1, alphatoTime - 300);
        madnes_alpha_to("mystery_choose_middle_group", 1, alphatoTime - 300);
        madnes_alpha_to("mystery_choose_right_group", 1, alphatoTime - 300);
    }, 1000);


    setTimeout(function() {

        madnes_set_texture("mystery_img_choose_right", "symbol_Mystery_standing_json");
        madnes_anim_add("mystery_img_choose_right", "anim_myst_stand", icons["symbol_Mystery"]["stand"]);

        madnes_set_texture("mystery_img_choose_middle", "symbol_Mystery_standing_json");
        madnes_anim_add("mystery_img_choose_middle", "anim_myst_stand", icons["symbol_Mystery"]["stand"]);

        madnes_set_texture("mystery_img_choose_left", "symbol_Mystery_standing_json");
        madnes_anim_add("mystery_img_choose_left", "anim_myst_stand", icons["symbol_Mystery"]["stand"]);

        mystery_anim_play("mystery_img_choose_right", true);
        madnes_anim_add_oncomplete("mystery_img_choose_right", mystery_anim_play.bind(this, "mystery_img_choose_right", false));

        mystery_anim_play("mystery_img_choose_middle", true);
        madnes_anim_add_oncomplete("mystery_img_choose_middle", mystery_anim_play.bind(this, "mystery_img_choose_middle", false));

        mystery_anim_play("mystery_img_choose_left", true);
        madnes_anim_add_oncomplete("mystery_img_choose_left", mystery_anim_play.bind(this, "mystery_img_choose_left", false));

        start_mystery_rope_swing();

    }, alphatoTime + 100);

    setTimeout(function() {
        mystery_enable_buttons();
        mystery_click_timeout = setTimeout(mystery_autostart, 12000); //12000
    }, 1000);
}

function mystery_disable_buttons()
{
    mystery_buttons_disabled = true;

    for(var i in myst_wins) {
        madnes_sprite_set_frame_name("mystery_btn_choose_" + i, "btn_choose_disabled");
    }
}

function mystery_enable_buttons()
{
    mystery_buttons_disabled = false;

    for(var i in myst_wins) {
        madnes_sprite_set_frame("mystery_btn_choose_" + i, "btn_choose_basic");
    }
}

function mystery_autostart()
{
    var selected = get_array_rand(myst_choices);
    mystery_win_start(selected);
}

var myst_choices = ['left', 'middle', 'right'];

var myst_wins = {
    'left': 0,
    'middle': 0,
    'right': 0,
};

var myst_wins_tmp = {
    'left': 0,
    'middle': 0,
    'right': 0,
};

var myst_win_coefs = {
    'left': 1,
    'middle': 1,
    'right': 1,
};

function mystery_clear_wins()
{
    for(var i in myst_wins) {
        myst_wins[i] = 0;
        myst_wins_tmp[i] = 0;
        madnes_set_text("mystery_win_txt_" + i, 0);
    }
}

/**
 * @param {String} selected
 * @param {number} win
 * @param {Array} factors
 */
function mystery_set_wins(selected, win, factors)
{
    var factorsCopy = factors.slice();

    mystery_clear_wins();
    myst_wins[selected] = madnes_money_to_coin(win);
    for(var i in myst_wins) {
        if(myst_wins[i] == 0) {
            var facValue = (Math.random() > 0.5) ? factorsCopy.pop() : factorsCopy.shift();

            myst_wins[i] = madnes_money_to_coin(facValue * mystery_win_set['multiplier']);
        }
    }

}

function getMaxMystWin()
{
    var max = myst_wins['left'];

    for(var i in myst_wins) {
        if(myst_wins[i] > max) {
            max = myst_wins[i];
        }
    }

    return max;
}

var mystery_start_locked = false;

export function mystery_win_start(selected)
{
    if(mystery_start_locked) {
        return true;
    }

    mystery_start_locked = true;

    mystery_set_wins(selected, mystery_win_set['win'] * mystery_win_set['multiplier'], server_result['result']['gameSpecifics']['mysteryFactors']);

    var fontSize = 80;
    var maxWinValue = getMaxMystWin();
    madnes_set_font_size("mystery_win_txt_left", fontSize);
    madnes_set_text("mystery_win_txt_left", maxWinValue);

    var fSize = calcFontSize(fontSize, 180, madnes_get_dimension_wi("mystery_win_txt_left"));

    madnes_set_font_size("mystery_win_txt_left", fSize);
    madnes_set_font_size("mystery_win_txt_middle", fSize);
    madnes_set_font_size("mystery_win_txt_right", fSize);

    var textShift = get_text_shift(origFontSize, fSize);

    madnes_audio_play("mystery_btn");

    madnes_anim_stop("mystery_img_choose_" + selected);
    clearTimeout(mystery_anim_timeouts["mystery_img_choose_" + selected]);

    madnes_set_texture("mystery_img_choose_" + selected, "symbol_Mystery_sheet_json");
    madnes_anim_add("mystery_img_choose_" + selected, "anim_myst_select", icons["symbol_Mystery"]["anim"]);
    madnes_anim_add_oncomplete("mystery_img_choose_" + selected, function() {
        madnes_anim_stop("mystery_img_choose_" + selected);
    });

    madnes_set_text("mystery_win_txt_left", "0");
    madnes_set_text("mystery_win_txt_middle", "0");
    madnes_set_text("mystery_win_txt_right", "0");

    madnes_anim_play("mystery_img_choose_" + selected, "anim_myst_select", 30);

    //setTimeout(function() {
    madnes_alpha_to("mystery_btn_choose_left", 0, 700);
    madnes_alpha_to("mystery_btn_choose_right", 0, 700);
    madnes_alpha_to("mystery_btn_choose_middle", 0, 700, function () {

        madnes_set_pos_y("mystery_win_txt_left", mystery_win_txt_pos - textShift);
        madnes_set_pos_y("mystery_win_txt_middle", mystery_win_txt_pos - textShift);
        madnes_set_pos_y("mystery_win_txt_right", mystery_win_txt_pos - textShift);

    });
    //}, 100);

    setTimeout(function() {

        madnes_set_visible("mystery_btn_choose_left", false);
        madnes_set_visible("mystery_btn_choose_right", false);
        madnes_set_visible("mystery_btn_choose_middle", false);

        madnes_set_alpha('mystery_win_txt_right', 0.4);
        madnes_set_alpha('mystery_win_txt_middle', 0.4);
        madnes_set_alpha('mystery_win_txt_left', 0.4);

        madnes_set_alpha('mystery_win_txt_' + selected, 1);

        madnes_set_visible("mystery_win_txt_right", true);
        madnes_set_visible("mystery_win_txt_middle", true);
        madnes_set_visible("mystery_win_txt_left", true);

        madnes_audio_loop("mystery_count");

        setTimeout(function() {

            mystery_add_win_count(selected, function() {

                madnes_audio_stop("mystery_count");
                madnes_audio_play("mystery_win");

                //madnes_audio_stop("mystery_count");
                setTimeout(mystery_win_end.bind(this), 2600);

            });

        }, 200)

    }, 500);
}

var madnes_mystery_count_max = 0;
function mystery_add_win_count(selected, callback)
{
    var times = array_shuffle([1500, 1000, 800]);
    var defTime = 2000;

    var anim1 = new Promise(function(res)
    {
        var leftCounter = new WinCounter();
        leftCounter.onUpdate(function(val)
        {
            madnes_set_text("mystery_win_txt_left", Math.round(val));
        });

        leftCounter.run(0, myst_wins["left"], selected == "left" ? defTime : times.shift()).then(res);
    });

    var anim2 = new Promise(function(res)
    {
        var middleCounter = new WinCounter();
        middleCounter.onUpdate(function(val)
        {
            madnes_set_text("mystery_win_txt_middle", Math.round(val));
        });

        middleCounter.run(0, myst_wins["middle"], selected == "middle" ? defTime : times.shift()).then(res);
    });

    var anim3 = new Promise(function(res)
    {
        var rightCounter = new WinCounter();
        rightCounter.onUpdate(function(val)
        {
            madnes_set_text("mystery_win_txt_right", Math.round(val));
        });

        rightCounter.run(0, myst_wins["right"], selected == "right" ? defTime : times.shift()).then(res);
    });

    Promise.all([anim1, anim2, anim3]).then(callback);
}

function mystery_win_end()
{
    madnes_set_win(win * 1 + mystery_win_set['win'] * mystery_win_set['multiplier']);

    // win = win * 1 + mystery_win_set['win'] * mystery_win_set['multiplier'];
    // spin_win = spin_win * 1 + mystery_win_set['win'] * mystery_win_set['multiplier'];

    mystery_click_timeout = null;

    stop_rope_swing_audio();

    if(mystery_audio_loaded)
    {
        //setTimeout(function() {

        madnes_audio_fade_to('mystery_background', 0, 800, function() {
            madnes_audio_stop('mystery_background');
        });

        //}, 400);
    }

    setTimeout(function() {

        if(in_free_spins)
        {
            madnes_audio_loop("BACKGROUND_FS");
        }
        else
        {
            madnes_audio_loop('BACKGROUND');
        }

        mystery_hide(function() {
            //madnes_show_skip_btn = madnes_show_skip_btn_tmp;

            //madnes_show_skip();

            mystery_enable_buttons();
            fadeout_all_reel_bonus('mystery');

            // madnes_show_btns();

            inc_result_control_pos();
            // result_control_pos++;
            result_control_part();

        });

    }, 1400);
}

function mystery_hide(callback)
{
    mystery_start_locked = false;

    show_all_symols();
    fadeout_black_screen();

    stop_mystery_timeout_anims();
    stop_mystery_rope_swing();

    madnes_anim_stop("mystery_img_choose_left");
    madnes_anim_stop("mystery_img_choose_middle");
    madnes_anim_stop("mystery_img_choose_right");

    madnes_set_texture("mystery_img_choose_left", "symbols_atlas");
    madnes_sprite_set_frame_name("mystery_img_choose_left", "symbol_Mystery");

    madnes_set_texture("mystery_img_choose_middle", "symbols_atlas");
    madnes_sprite_set_frame_name("mystery_img_choose_middle", "symbol_Mystery");

    madnes_set_texture("mystery_img_choose_right", "symbols_atlas");
    madnes_sprite_set_frame_name("mystery_img_choose_right", "symbol_Mystery");

    var fadeoutToTime = 1000;

    setTimeout(function() {

        madnes_alpha_to("mystery_background", 0, fadeoutToTime, function () {

            madnes_set_pos("mystery_background", -9999, -9999);
            madnes_set_visible("mystery_background", false);

            madnes_set_pos("mystery_choose_left_group", -9999, -9999);
            madnes_set_visible("mystery_choose_left_group", false);

            madnes_set_pos("mystery_choose_middle_group", -9999, -9999);
            madnes_set_visible("mystery_choose_middle_group", false);

            madnes_set_pos("mystery_choose_right_group", -9999, -9999);
            madnes_set_visible("mystery_choose_right_group", false);

            madnes_set_pos("mystery_btn_choose_left", -9999, -9999);
            madnes_set_pos("mystery_btn_choose_middle", -9999, -9999);
            madnes_set_pos("mystery_btn_choose_right", -9999, -9999);

            madnes_set_pos("mystery_win_txt_right", -9999, -9999);
            madnes_set_visible("mystery_win_txt_right", false);

            madnes_set_pos("mystery_win_txt_middle", -9999, -9999);
            madnes_set_visible("mystery_win_txt_middle", false);

            madnes_set_pos("mystery_win_txt_left", -9999, -9999);
            madnes_set_visible("mystery_win_txt_left", false);

            change_bar(in_free_spins ? "fs" : "logo").then(callback);

        });

        madnes_alpha_to("mystery_label", 0, fadeoutToTime, function() {

            madnes_set_pos("mystery_label", -9999, -9999);
            madnes_set_visible("mystery_label", false);

        });

        madnes_alpha_to("mystery_btn_choose_left", 0, fadeoutToTime);
        madnes_alpha_to("mystery_btn_choose_middle", 0, fadeoutToTime);
        madnes_alpha_to("mystery_btn_choose_right", 0, fadeoutToTime);

        madnes_alpha_to("mystery_win_txt_left", 0, fadeoutToTime);
        madnes_alpha_to("mystery_win_txt_middle", 0, fadeoutToTime);
        madnes_alpha_to("mystery_win_txt_right", 0, fadeoutToTime);

    }, 600);

    madnes_alpha_to("mystery_choose_left_group", 0, fadeoutToTime - 400);
    madnes_alpha_to("mystery_choose_middle_group", 0, fadeoutToTime - 400);
    madnes_alpha_to("mystery_choose_right_group", 0, fadeoutToTime - 400);
}

export function stop_mystery_click_timeout()
{
    if(mystery_click_timeout != null) {
        clearTimeout(mystery_click_timeout);
    }
}